const PageEventsConstants = {
    GWC_IMALI_VIEW_PAGE: 'gwc-imali-view-page',
    GWC_IMALI_QR_LOADED: 'gwc-imali-qr-loaded',
    GWC_IMALI_QR_TIMEOUT: 'gwc-imali-qr-timeout',
    GWC_IMALI_LINKING_SUCCESSFUL: 'gwc-imali-linking-successful',
    GWC_PAYMENT_REVIEW_SCREEN_LOADED: 'gwc-payment-review-screen-loaded',
    GWC_PAYMENT_CONFIRM_STATUS: 'gwc-payment-confirm-status',
    GWC_PAYMENT_PROMO_LOADED: 'gwc-payment-promo-loaded',
    GWC_PAYMENT_PIN_PAGE_LOADED: 'gwc-payment-pin-page-loaded',
    GWC_PAYMENT_PIN_ERROR: 'gwc-payment-pin-error',
    GWC_PIN_PAGE_INCORRECT_PIN: 'gwc-pin-page-incorrect-pin',
    GWC_PAYMENT_PIN_TOKEN_SUBMISSION_ERROR:
        'gwc-payment-token-submission-error',
    GWC_SUCCESS_SCREEN: 'gwc-success-screen',
    GWC_ERROR_PAGE: 'gwc-error-page',
    GWC_IN_APP_CHALLENGE_INSTRUCTIONS_LOADED:
        'gwc-in-app-challenge-instructions-loaded',
    GWC_IN_APP_CHALLENGE_CONFIRMATION_CLICKED:
        'gwc-in-app-challenge-confirmation-clicked',
    GWC_IN_APP_CHALLENGE_SUCCESS: 'gwc-in-app-challenge-success',
    GWC_IN_APP_CHALLENGE_FAILED: 'gwc-in-app-challenge-failed',
    GWC_PROVIDER_CHALLENGE_PAGE_LOADED: 'gwc-provider-challenge-page-loaded',
    GWC_GET_CHALLENGE_REQUEST_SUCCESS: 'gwc-get-challenge-request-success',
    GWC_GET_CHALLENGE_REQUEST_ERROR: 'gwc-get-challenge-request-error',
    GWC_PROVIDER_REDIRECT_PAGE_LOADED: 'gwc-provider-redirect-page-loaded',
    GWC_VERIFY_CHALLENGE_REQUEST_SUCCESS:
        'gwc-verify-challenge-request-success',
    GWC_PROCESS_CHALLENGE_REQUEST_SUCCESS:
        'gwc-process-challenge-request-success',
    GWC_VERIFY_CHALLENGE_REQUEST_ERROR: 'gwc-verify-challenge-request-error',
    GWC_PROCESS_CHALLENGE_REQUEST_ERROR: 'gwc-process-challenge-request-error',
    GWC_PAYMENT_AGREEMENT_PAGE_LOADED: 'gwc-payment-agreement-page-loaded',
    GWC_SELECT_INSTALLMENT_PAGE_LOADED: 'gwc-select-installment-page-loaded',
    GWC_PAYMENT_REVIEW_SCREEN_LOADED_WITH_INSTALLMENT_OPTION_SELECTED:
        'gwc-payment-review-screen-with-installment-option-selected',
    GWC_PROMO_WIDGET_LOADED: 'gwc-promo-widget-loaded',
    GOPAY_LINKING_CONSENT_PAGE: 'gopay-linking-consent-page',
    GOPAY_LINKING_OTP_PAGE: 'gopay-linking-otp-page',
    GOPAY_ACCOUNT_CREATION_LINKING_CONSENT_PAGE:
        'gopay-account-creation-linking-consent-page',
    GOPAY_LINKING_INPUT_NAME_PAGE: 'gopay-linking-input-name-page',
    TSEL_WALLET_DASHBOARD_LANDING_PAGE:
        'telkomsel-wallet-dashboard-landing-page',
    TSEL_WALLET_TRANSACTION_HISTORY_PAGE:
        'telkomsel-wallet-transaction-history-page',
    TSEL_WALLET_TRANSACTION_DETAILS_PAGE:
        'telkomsel-wallet-transaction-details-page',
    TSEL_WALLET_FAQ_PAGE: 'telkomsel-wallet-faq-page',
    TSEL_WALLET_FAQ_DETAILS_PAGE: 'telkomsel-wallet-faq-details-page',
    TSEL_WALLET_ERROR_PAGE: 'telkomsel-wallet-error-page',
    GOPAY_LINKING_SUCCESS_PAGE: 'gopay-linking-success-page',
    GWC_DASHBOARD_REQUEST_SUCCESS: 'gwc-wallet-dashboard-request-success',
    GWC_DASHBOARD_REQUEST_ERROR: 'gwc-wallet-dashboard-request-error',
    GWC_TRANSACTION_HISTORY_REQUEST_SUCCESS:
        'gwc-transaction-history-request-success',
    GWC_TRANSACTION_HISTORY_REQUEST_ERROR:
        'gwc-transaction-history-request-error',
    CLICKSTREAM_EVENT_UI_PAGE: 'page',
}

const ComponentEventsConstants = {
    GWC_PAYMENT_CONFIRM_CLICKED: 'gwc-payment-confirm-clicked',
    GWC_PAYMENT_DETAILS_TNC_CLICKED: 'gwc-payment-details-tnc-clicked',
    GWC_PAYMENT_FORGOT_PIN_CLICKED: 'gwc-payment-forgot-pin-clicked',
    GWC_PAYMENT_PROMO_WIDGET_CLICKED: 'gwc-payment-promo-widget-clicked',
    GWC_PAYMENT_PROMO_WIDGET_CLOSED: 'gwc-payment-promo-widget-closed',
    GWC_PAYMENT_PROMO_APPLIED: 'gwc-payment-promo-applied',
    GWC_PAYMENT_PROMO_REMOVED: 'gwc-payment-promo-removed',
    GWC_PIN_PAGE_MAB_AGREEMENT_CLICKED: 'gwc-pin-page-mab-agreement-clicked',
    GWC_PIN_PAGE_FORGOT_PIN_CLICKED: 'gwc-pin-page-forgot-pin-clicked',
    GWC_PAYMENT_PIN_TOKEN_SUBMITTED: 'gwc-payment-token-submitted',
    GWC_PAYMENT_PIN_SUBMITTED: 'gwc-payment-pin-submitted',
    GWC_RECOMMENDED_PAYMENT_METHODS_CLICKED:
        'gwc-recommended-payment-methods-clicked',
    GWC_BREAKDOWN_CLICKED: 'gwc-breakdown-clicked',
    GWC_PROVIDER_REDIRECT_CONFIRM_CLICKED:
        'gwc-provider-redirect-confirm-clicked',
    GWC_VIEW_ALL_PAYMENT_METHODS_BUTTON_CLICKED:
        'gwc-view-all-payment-methods-button-clicked',
    GWC_VIEW_ALL_PAYMENT_METHODS_LOADED: 'gwc-view-all-payment-methods-loaded',
    GWC_PAYMENT_METHOD_CHANGED: 'gwc-payment-method-changed',
    GWC_SELECT_INSTALLMENT_CLICKED: 'gwc-select-installment-clicked',
    GWC_INSTALLMENT_OPTION_SELECTED: 'gwc-installment-option-selected',
    GWC_INSTALLMENT_OPTION_CLOSE_CLICKED:
        'gwc-installment-option-close-clicked',
    GWC_PAYMENT_CONFIRM_CLICKED_WITH_INSTALLMENT_OPTION_SELECTED:
        'gwc-payment-confirm-clicked-with-installment-option-selected',
    GOPAY_LINKING_CONSENT_SUBMITTED: 'gopay-linking-consent-submitted',
    GWC_LINKING_CONSENT_REQUEST_ERROR: 'gwc-linking-consent-request-error',
    GWC_LINKING_CONSENT_REQUEST_SUCCESS: 'gwc-linking-consent-request-success',
    GWC_VALIDATE_LINKING_REQUEST_SUCCESS:
        'gwc-validate-linking-request-success',
    GWC_VALIDATE_LINKING_REQUEST_ERROR: 'gwc-validate-linking-request-error',
    GWC_LINKING_VALIDATE_OTP_REQUEST_SUCCESS:
        'gwc-linking-validate-otp-request-success',
    GWC_LINKING_VALIDATE_OTP_REQUEST_ERROR:
        'gwc-linking-validate-otp-request-error',
    GWC_LINKING_RESEND_OTP_REQUEST_SUCCESS:
        'gwc-linking-resend-otp-request-success',
    GWC_LINKING_RESEND_OTP_REQUEST_ERROR:
        'gwc-linking-resend-otp-request-error',
    GWC_LINKING_VALIDATE_PIN_REQUEST_SUCCESS:
        'gwc-linking-validate-pin-request-success',
    GWC_LINKING_VALIDATE_PIN_REQUEST_ERROR:
        'gwc-linking-validate-pin-request-error',
    GOPAY_LINKING_CONSENT_TNC_CLICKED: 'gopay-linking-consent-tnc-clicked',
    GOPAY_LINKING_CONSENT_PRIVACY_POLICY_CLICKED:
        'gopay-linking-consent-privacy-policy-clicked',
    GOPAY_LINKING_OTP_RESEND_CLICKED: 'gopay-linking-otp-resend-clicked',
    GOPAY_LINKING_CONTINUE_SET_UP_PIN_CLICKED:
        'gopay-linking-continue-set-up-pin-clicked',
    TSEL_WALLET_LANDING_PAGE_HISTORY_CLICKED:
        'telkomsel-wallet-landing-page-history-clicked',
    TSEL_WALLET_LANDING_PAGE_TRANSACTION_DETAILS_CLICKED:
        'telkomsel-wallet-landing-page-transaction-details-clicked',
    TSEL_WALLET_LANDING_PAGE_FAQ_CLICKED:
        'telkomsel-wallet-landing-page-faq-clicked',
    TSEL_WALLET_HISTORY_TRANSACTION_DETAILS_CLICKED:
        'telkomsel-wallet-history-transaction-details-clicked',
    GWC_ACCOUNT_CREATION_REQUEST_SUCCESS:
        'gwc-account-creation-request-success',
    GWC_ACCOUNT_CREATION_REQUEST_ERROR: 'gwc-account-creation-request-error',
    GWC_ACCOUNT_CREATION_CONSENT_REQUEST_SUCCESS:
        'gwc-account-creation-consent-request-success',
    GWC_ACCOUNT_CREATION_CONSENT_REQUEST_ERROR:
        'gwc-account-creation-consent-request-error',
    GWC_ACCOUNT_CREATION_VALIDATE_OTP_REQUEST_SUCCESS:
        'gwc-account-creation-validate-otp-request-success',
    GWC_ACCOUNT_CREATION_VALIDATE_OTP_REQUEST_ERROR:
        'gwc-account-creation-validate-otp-request-error',
    GWC_ACCOUNT_CREATION_INPUT_NAME_REQUEST_SUCCESS:
        'gwc-account-creation-input-name-request-success',
    GWC_ACCOUNT_CREATION_INPUT_NAME_REQUEST_ERROR:
        'gwc-account-creation-input-name-request-error',
    GWC_ACCOUNT_CREATION_STATUS_POLLING_REQUEST_SUCCESS:
        'gwc-account-creation-status-polling-request-success',
    CLICKSTREAM_EVENT_UI_COMPONENT: 'component',
}

export { PageEventsConstants, ComponentEventsConstants }
